export default {
	calendars: state => state.calendars,

	firstCalendarId(state) {
		const sorted = [...state.calendars].sort((a, b) =>
			(a.name || '').localeCompare(b.name || '', undefined, {
				sensitivity: 'base',
			})
		)

		return sorted[0]?.id ?? null
	},

	hasCalendars: state => state.calendars.length > 0,

	isBootstrapped: state => state.bootstrapped,

	isLoading: state => state.loading,

	officeHoursStatus: state => state.officeHoursStatus,

	officeNumber: state => state.officeNumber,

	officeNumberLabel(state) {
		const status = (state.officeHoursStatus || '').toLowerCase()

		if (status === 'open') {
			return 'Open Hours Office Number:'
		}

		if (status === 'lunch') {
			return 'Lunch Hours Office Number:'
		}

		if (status === 'closed' || status === 'close') {
			return 'After Hours Office Number:'
		}

		return 'Office Number:'
	},

	partnerName: state => state.partnerName,

	shortId: state => state.shortId,

	timezone: state => state.timezone,
}
